import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SectionHeading } from "./Section";
import { useLang } from "../../i18n";

export const Approach = () => {
  const { t } = useLang();
  const a = t.approach;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.8", "end 0.4"] });
  const lineH = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section id="approach" className="relative py-24 md:py-36 bg-ink-surface/40" data-testid="approach-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <SectionHeading overline={a.overline} title={a.title} />

        <div ref={ref} className="relative mt-16 ml-2 md:ml-0">
          {/* track */}
          <div className="absolute left-[15px] md:left-1/2 top-0 bottom-0 w-px bg-white/10 md:-translate-x-1/2" />
          <motion.div style={{ height: lineH }} className="absolute left-[15px] md:left-1/2 top-0 w-px bg-flame md:-translate-x-1/2 shadow-[0_0_12px_2px_rgba(255,106,0,0.5)]" />

          <div className="space-y-8 md:space-y-2">
            {a.steps.map((s, i) => {
              const left = i % 2 === 0;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: left ? -30 : 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                  className={`relative flex md:grid md:grid-cols-2 md:gap-12 items-center ${left ? "" : "md:[&>*:first-child]:order-2"}`}
                  data-testid={`approach-step-${i}`}
                >
                  <div className={`hidden md:block ${left ? "text-right pr-12" : "pl-12"}`}>
                    <StepCard s={s} i={i} align={left ? "right" : "left"} />
                  </div>
                  {/* node */}
                  <span className="absolute left-[15px] md:left-1/2 md:-translate-x-1/2 z-10 flex h-8 w-8 items-center justify-center rounded-full border border-flame/40 bg-[#050505]">
                    <span className="h-2.5 w-2.5 rounded-full bg-flame" />
                  </span>
                  <div className={`pl-12 md:hidden`}>
                    <StepCard s={s} i={i} align="left" />
                  </div>
                  <div className="hidden md:block" />
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

const StepCard = ({ s, i, align }) => (
  <div className={`inline-block ${align === "right" ? "md:ml-auto" : ""}`}>
    <span className="font-mono text-xs text-flame">STEP {String(i + 1).padStart(2, "0")}</span>
    <h3 className="mt-1.5 font-heading text-2xl md:text-3xl font-bold">{s.t}</h3>
    <p className="mt-1.5 text-white/55 max-w-xs md:inline-block">{s.d}</p>
  </div>
);
